import SettingSidebar from './setting-sidebar';
import { SidebarProvider, SidebarTrigger } from './ui/sidebar';

import { Outlet } from 'react-router-dom';

const SettingLayout = () => {
	return (
		<SidebarProvider>
			<SettingSidebar />
			<main className="flex-1">
				<SidebarTrigger />
				<div className="py-6">
					<Outlet />
				</div>
			</main>
		</SidebarProvider>
	);
};

export default SettingLayout;
